// extracted by mini-css-extract-plugin
export default {"TechnicalWorkingAlert":"styles_TechnicalWorkingAlert__JhCKO","is-impersonation":"styles_is-impersonation__Napg2","ant-alert-content":"styles_ant-alert-content__L02CB"};